import { useState } from "react";
import { LIB_VERSION } from "../version";
import { baseUrls, clientNames } from "../types";
function createPopupString() {
    return `height=750,width=400,left=${window.innerWidth / 2 - 200},top=${window.innerHeight / 2 - 375},resizable=yes,scrollbars=yes,toolbar=yes,menubar=true,location=no,directories=no, status=yes`;
}
const overlayId = "__crossmint-overlay__";
const addLoadingOverlay = () => {
    const overlayEl = document.createElement("div");
    overlayEl.setAttribute("id", overlayId);
    const overlayStyles = {
        width: "100vw",
        height: "100vh",
        "background-color": "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        "z-index": "99999999",
        top: "0",
        left: "0",
    };
    Object.assign(overlayEl.style, overlayStyles);
    document.body.appendChild(overlayEl);
};
const removeLoadingOverlay = () => {
    const overlayEl = document.getElementById(overlayId);
    if (overlayEl)
        overlayEl.remove();
};
export default function useCrossMintModal({ development, clientId, showOverlay }) {
    const [connecting, setConnecting] = useState(false);
    const createPopup = (mintConfig, collectionTitle, collectionDescription, collectionPhoto, mintTo, emailTo, listingId) => {
        const urlOrigin = development ? baseUrls.dev : baseUrls.prod;
        const getMintQueryParams = () => {
            const mintQueryParams = {
                clientId: clientId,
                closeOnSuccess: "false",
                clientName: clientNames.reactUi,
                clientVersion: LIB_VERSION,
                mintConfig: JSON.stringify(mintConfig),
            };
            if (collectionTitle)
                mintQueryParams.collectionTitle = collectionTitle;
            if (collectionDescription)
                mintQueryParams.collectionDescription = collectionDescription;
            if (collectionPhoto)
                mintQueryParams.collectionPhoto = collectionPhoto;
            if (mintTo)
                mintQueryParams.mintTo = mintTo;
            if (emailTo)
                mintQueryParams.emailTo = emailTo;
            if (listingId)
                mintQueryParams.listingId = listingId;
            return new URLSearchParams(mintQueryParams).toString();
        };
        const callbackUrl = encodeURIComponent(`${urlOrigin}/checkout/mint?${getMintQueryParams()}`);
        const url = `${urlOrigin}/signin?callbackUrl=${callbackUrl}`;
        const pop = window.open(url, "popUpWindow", createPopupString());
        if (pop) {
            registerListeners(pop);
            if (showOverlay) {
                addLoadingOverlay();
            }
        }
        else {
            setConnecting(false);
            console.error("Failed to open popup window");
        }
    };
    const connect = (mintConfig, collectionTitle, collectionDescription, collectionPhoto, mintTo, emailTo, listingId) => {
        if (connecting)
            return;
        setConnecting(true);
        createPopup(mintConfig, collectionTitle, collectionDescription, collectionPhoto, mintTo, emailTo, listingId);
    };
    function registerListeners(pop) {
        const timer = setInterval(function () {
            if (pop.closed) {
                clearInterval(timer);
                setConnecting(false);
                if (showOverlay) {
                    removeLoadingOverlay();
                }
            }
        }, 500);
    }
    return { connecting, connect };
}
//# sourceMappingURL=useCrossmintModal.js.map